import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dreamy%20anime%20style%20classroom%20scene%20with%20cherry%20blossoms%20floating%2C%20soft%20pastel%20pink%20and%20cream%20color%20palette%2C%20gentle%20sunlight%20streaming%20through%20windows%2C%20ethereal%20atmosphere%2C%20beautiful%20lighting%2C%20romantic%20and%20soft%20aesthetic%2C%20no%20text%20no%20characters&width=1800&height=800&seq=hero-bg-main&orientation=landscape"
          alt="白丝JK二次元文化背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium mb-6 backdrop-blur-sm">
          正版周边 · 品质保障
        </span>
        <h1 className="font-heading text-4xl md:text-6xl text-background-50 leading-tight mb-4 drop-shadow-lg">
          白丝JK正版周边<br />购买指南
        </h1>
        <p className="text-base md:text-lg text-background-100/90 max-w-2xl mx-auto mb-8 leading-relaxed drop-shadow-md">
          汇聚白丝JK相关正版手办、JK制服、同人文化资讯，帮助每一位爱好者找到心仪的高品质周边产品与可靠购买渠道。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/shouban"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap transform hover:scale-105"
          >
            浏览手办周边
          </Link>
          <Link
            to="/category/gouwu"
            className="px-8 py-3 rounded-full bg-background-50/90 text-foreground-800 font-medium text-sm hover:bg-background-50 transition-all duration-300 cursor-pointer whitespace-nowrap backdrop-blur-sm transform hover:scale-105"
          >
            查看购买指南
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/50 flex items-start justify-center">
          <div className="w-1.5 h-3 rounded-full bg-background-50/70 mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}